/*
# -----------------------------------------------------------------------------
# Component: riskAccumListMixin.js
# Author: ssy@pst.sg
# Created Date: 27/Aug/2019
# Comments: Responsible for all data table related functionality
# -----------------------------------------------------------------------------
*/
import * as TableConst from '@/mixins/table'

export const riskAccumListMixin = {
  data() {
    return {
      accumList: false,
      riskAccumDetailItems: [],
      totalItemsRiskAccumDetail: 0,
      riskAccumDetailItemsTotal: [],
      treatyItemList: false,
      count: 1,
      totalTreatyTotal: 0,
      treatyTotalItems: [],
      blkGrpItems: [],
      totalItemsBlkGrp: 0,
      blkSubGrp1Items: [],
      totalItemsBlkSubGrp1: 0,
      blkSubGrp2Items: [],
      totalItemsBlkSubGrp2: 0,
      blkItems: [],
      totalItemsBlk: 0,
      vslDetItems: [],
      totalItemsVslDet: 0,
      riskAccumFireRiskRIItem: [],
      riskAccumCargoRiskRIItem: [],
      riskAccumHullRiskRIItem: [],
      riskAccumMotorRiskRIItem: [],
      riskAccumMiscRiskRIItem: [],
      extraBlkPolRiskBlkItem: [],
      totalItemsRiskAccumFireRiskRI: 0,
      totalItemsRiskAccumCargoRiskRI: 0,
      totalItemsRiskAccumHullRiskRI: 0,
      totalItemsRiskAccumMotorRiskRI: 0,
      totalItemsRiskAccumMiscRiskRI: 0,
      totalItemsExtraBlkPolRiskBlk: 0,
      blkGrpDisable: false,
      blksGrp1Disable: false,
      blksGrp2Disable: false,
      blkDisable: false,
      accumBlkItem: [],
      newColumns: [],
      ccTtyRet: undefined,
      selectedRiskAccumDetailColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'insdName1',
        'cfmRiskDisp',
        'currency',
        'sumInsdDisp',
        'ttyNo1Disp',
        'ttyNo2Disp',
        'ttyNo3Disp',
        'ttyNo4Disp',
        'ttyNo5Disp',
        'ttyNo6Disp',
        'ttyNo7Disp',
        'ttyNo8Disp',
        'ttyNo9Disp',
        'ttyNo10Disp',
        'coinSumInsdDisp',
        'coinPct',
        'statSumInsdDisp',
        'statPct',
        'facSumInsdDisp',
        'facPct',
        'treatySumInsdDisp',
        'treatyPct',
        'grossRetDisp',
        'grossPct',
        'qShareSumInsdDisp',
        'qSharePct',
        'netRetDisp',
        'netPct',
        'comDate',
        'expDate'
      ],
      // 210901 SSY: New Columns in risk accumulation listing(Fire Accumulation only)
      // Start
      selectedRiskAccumDetailFireColumns: [
        'polNo',
        'renCnt',
        'endtCnt',
        'insdName1',
        'riskNo',
        'busCls',
        'cfmRiskDisp',
        'bldgNo',
        'unitNo',
        'currency',
        'sumInsdDisp',
        'ttyNo1Disp',
        'ttyNo2Disp',
        'ttyNo3Disp',
        'ttyNo4Disp',
        'ttyNo5Disp',
        'ttyNo6Disp',
        'ttyNo7Disp',
        'ttyNo8Disp',
        'ttyNo9Disp',
        'ttyNo10Disp',
        'coinSumInsdDisp',
        'coinPct',
        'statSumInsdDisp',
        'statPct',
        'facSumInsdDisp',
        'facPct',
        'treatySumInsdDisp',
        'treatyPct',
        'grossRetDisp',
        'grossPct',
        'qShareSumInsdDisp',
        'qSharePct',
        'netRetDisp',
        'netPct',
        'comDate',
        'expDate'
      ],
      // End
      selectedTreatyTotalColumns: ['ttyNo', 'ttyLimDisp', 'treatyTotalDisp', 'balDisp'],
      selectedBlkGrpsColumns: ['blkGrp', 'blkGrpDescS'],
      selectedBlkSubGrp1Columns: ['blkSubGrp1', 'blkSubGrp1DescS'],
      selectedBlkSubGrp2Columns: ['blkSubGrp2', 'blkSubGrp2DescS'],
      selectedBlkColumns: ['blk', 'blkGrp', 'blkDesc'],
      selectedVslDetColumns: ['vesNo', 'vesName'],
      selectedRiskAccumFireRiskRIColumns: ['riType', 'riCo', 'acctNoSfx', 'comDate', 'expDate', 'riSIDisp', 'riPremDisp', 'riComm1Disp', 'riComm2Disp', 'riComm3Disp'],
      selectedRiskAccumCargoRiskRIColumns: ['riType', 'riCo', 'acctNoSfx', 'comDate', 'expDate', 'riSIDisp', 'riPremDisp', 'riComm1Disp', 'riComm2Disp', 'riComm3Disp'],
      selectedRiskAccumHullRiskRIColumns: ['riType', 'riCo', 'acctNoSfx', 'comDate', 'expDate', 'riSIDisp', 'riPremDisp', 'riComm1Disp', 'riComm2Disp', 'riComm3Disp'],
      selectedRiskAccumMotorRiskRIColumns: ['riType', 'riCo', 'acctNoSfx', 'comDate', 'expDate', 'riSIDisp', 'riPremDisp', 'riComm1Disp', 'riComm2Disp', 'riComm3Disp'],
      selectedRiskAccumMiscRiskRIColumns: ['riType', 'riCo', 'acctNoSfx', 'comDate', 'expDate', 'riSIDisp', 'riPremDisp', 'riComm1Disp', 'riComm2Disp', 'riComm3Disp'],
      selectedRiskAccumExtraBlkColumns: ['seqNo', 'blkGrp', 'blkSGrp1', 'blkSGrp2', 'blk', 'floatSiLimDisp', 'floatPremDisp'],
      riskAccumDetailColumns: [
        { text: 'Policy No', value: 'polNo', width: '120px' },
        { text: 'Ren', value: 'renCnt', width: '75px' },
        { text: 'Endt', value: 'endtCnt', width: '75px' },
        { text: 'Insured Name', value: 'insdName1', width: '250px' },
        // 210901 SSY: New Columns in risk accumulation listing(Fire Accumulation only)
        // Start
        { text: 'Risk No', value: 'riskNo', width: '100px' },
        { text: 'Class', value: 'busCls', width: '100px' },
        { text: 'Confirm', value: 'cfmRisk', width: '100px' },
        { text: 'Confirm', value: 'cfmRiskDisp', width: '100px' },
        { text: 'Bldg', value: 'bldgNo', width: '300px' },
        { text: 'Unit', value: 'unitNo', width: '75px' },
        // End
        { text: 'Currency', value: 'currency', width: '120px' },
        { text: 'Sum', value: 'sumInsdDisp', width: '75px' },
        { text: 'Coins Sum', value: 'coinSumInsdDisp', width: '150px' },
        { text: 'Coins %', value: 'coinPct', width: '100px' },
        { text: 'Stat Sum', value: 'statSumInsdDisp', width: '100px' },
        { text: 'Stat %', value: 'statPct', width: '100px' },
        { text: 'Fac Sum', value: 'facSumInsdDisp', width: '100px' },
        { text: 'Fac %', value: 'facPct', width: '100px' },
        { text: 'Treaty Sum', value: 'treatySumInsdDisp', width: '150px' },
        { text: 'Treaty %', value: 'treatyPct', width: '100px' },
        { text: 'Gross', value: 'grossRetDisp', width: '100px' },
        { text: 'Gross %', value: 'grossPct', width: '100px' },
        { text: 'QShare Sum', value: 'qShareSumInsdDisp', width: '150px' },
        { text: 'QShare %', value: 'qSharePct', width: '120px' },
        { text: 'Net', value: 'netRetDisp', width: '100px' },
        { text: 'Net %', value: 'netPct', width: '100px' },
        { text: 'Com Date', value: 'comDate', width: '120px' },
        { text: 'Exp Date', value: 'expDate', width: '120px' }
      ],
      treatyTotalColumns: [
        { text: 'Treaty No.', value: 'ttyNo' },
        { text: 'Treaty Limit', value: 'ttyLimDisp' },
        { text: 'Amount Ceded', value: 'treatyTotalDisp' },
        { text: 'Balance', value: 'balDisp' }
      ],
      riskAccumColumns: [
        { text: 'RI Type', value: 'riType' },
        { text: 'RI Company', value: 'riCo' },
        { text: 'Acct No Sfx', value: 'acctNoSfx' },
        { text: 'Comm Date', value: 'comDate' },
        { text: 'Exp Date', value: 'expDate' },
        { text: 'RI Sum Insured (%)', value: 'riSIDisp' },
        { text: 'RI Premium', value: 'riPrem' },
        { text: 'RI Comm 1', value: 'riComm1' },
        { text: 'RI Comm 2', value: 'riComm2' },
        { text: 'RI Comm 3', value: 'riComm3' },
        { text: 'RI Premium', value: 'riPremDisp' },
        { text: 'RI Comm 1', value: 'riComm1Disp' },
        { text: 'RI Comm 2', value: 'riComm2Disp' },
        { text: 'RI Comm 3', value: 'riComm3Disp' }
      ],
      extraBlkColumns: [
        { text: 'Seq No.', value: 'seqNo' },
        { text: 'Blk Grp', value: 'blkGrp' },
        { text: 'Blk SGrp1', value: 'blkSGrp1' },
        { text: 'Blk SGrp2', value: 'blkSGrp2' },
        { text: 'Blk', value: 'blk' },
        { text: 'Sum Insured', value: 'floatSiLim' },
        { text: 'Premium', value: 'floatPrem' },
        { text: 'Sum Insured', value: 'floatSiLimDisp' },
        { text: 'Premium', value: 'floatPremDisp' }
      ],
      labels: {
        accumType: 'Accumulation Type',
        blkGrpLblS: 'Block Group Label',
        blkGrpLblL: 'Block Group Description',
        blksGrp1LblS: 'Block Sub Group 1 Label',
        blksGrp1LblL: 'Block Sub Group 1 Description',
        blksGrp2LblS: 'Block Sub Group 2 Label',
        blksGrp2LblL: 'Block Sub Group 2 Description',
        blksLblS: 'Block Label',
        blksLblL: 'Block Description',
        inclNorm: 'Normalised Block',
        asAtDate: 'As at Date',
        rtnLimKey: 'Retention Limit',
        currency: 'Currency',
        remark: 'Remark',
        accumBase: 'Accumulate based on',
        filterBy: 'Filter policies by',
        accumBlkLbl: '',
        // Total
        sumInsd: 'Sum Insured',
        CoIns: 'Coinsurance',
        stat: 'Statutory',
        fac: 'Facultative',
        treaty: 'Treaty',
        grossRet: 'Gross Retention',
        qShare: 'Quota Share',
        netRet: 'Net Retention',
        estMaxLoss: 'Estimated Maximum Loss',
        // Treaty totals
        ttyNo: 'Treaty No.',
        ttyLim: 'Treaty Limit',
        treatyTotal: 'Amount Ceded',
        bal: 'Balance'
      },
      riskAccumForm: {
        accumType: undefined,
        blkGrpLblS: undefined,
        blkGrpLblL: undefined,
        blksGrp1LblS: undefined,
        blksGrp1LblL: undefined,
        blksGrp2LblS: undefined,
        blksGrp2LblL: undefined,
        blksLblS: undefined,
        blksLblL: undefined,
        inclNorm: undefined,
        asAtDate: new Date(),
        asAtDateDisp: undefined,
        rtnLimKey: 0,
        currency: 'L',
        remark: undefined,
        accumBase: 'Gross',
        filterBy: 'Rel',
        accumBlkLbl: 'blk',
        format: 'PDF'
      },
      riskAccumDetailLabels: {
        // Standard
        riskDesc: 'Risk Group / No.',
        busCls: 'Business Class',
        siCurr: 'Sum Insured Currency',
        billCurr: 'Billing Currency',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        // Cargo Risk
        vesNo: 'Vessel No.',
        vesName: 'Vessel name',
        voyNo: 'Voyage No.',
        voyDate: 'Voyage Date',
        voyFromTo: 'Voyage From / To',
        voyDesc: 'Voyage Description',
        voyArea: 'Voyage Area',
        coverage: 'Coverage',
        comdtyType: 'Commodity',
        pkgType: 'Packing Type',
        surAgt: 'Survey Agent',
        setAgt: 'Settlement Agent',
        certBord: 'Certificate / Bordereaux',
        dclrCertNo: 'Declared Certificate No.',
        // Hull Risk
        vesDesc: 'Vessel Description',
        issDate: 'Issue Date',
        intCvrd: 'Interest Covered',
        imoRefNo: 'IMO Ref No.',
        chartRefNo: 'Chartered Ref No.',
        mortgagee: 'Mortgagee',
        yrBuilt: 'Year Built',
        vesFlag: 'Vessel Flag',
        vesCls: 'Vessel Class',
        vesType: 'Vessel Type',
        grt: 'Gross Registered Tonnes (GRT)',
        nrt: 'Net Registered Tonnes (NRT)',
        dwt: 'Dead Weight Tonnes (DWT)',
        vesConstn: 'Vessel Construction',
        vesOwn: 'Vessel Owner / Manager',
        vesAgt: 'Vessel Agent / Broker',
        // Fire Risk
        bldgNo: 'Block / House No.',
        unitNo: 'Unit No.',
        collNo: 'Collateral Ref No.',
        interest: 'Interest',
        riskLoc: 'Risk Location',
        riskPostCode: 'Postal Code',
        occpy: 'Occupancy',
        occpCls: 'Occupation Class',
        distCls: 'District Class',
        constnCls: 'Construction Class',
        occpClsLim: 'Occupation Class Limit',
        ownTent: 'Owner / Tenant',
        accmLdgPct: 'Loading %',
        roof: 'Roof Class',
        noStorey: 'No. of Storeys',
        latitude: 'Latitude X',
        longitude: 'Longitude Y',
        survRpt: 'Survey Report No.',
        survDate: 'Survey Date',
        // Motor Risk
        tarf: 'Tariff',
        cvrType: 'Cover Type',
        vehRegNo: 'Vehicle Registration No.',
        colour: 'Colour',
        certNo: 'Certificate of Insurance No.',
        certRef: 'Certificate of Insurance Ref',
        trailerRegNo: 'Trailer Registration No.',
        engNo: 'Engine No.',
        chasNo: 'Chassis No.',
        logBook: 'Log Book No.',
        vehMakeModel: 'Make / Model',
        yrManuf: 'Year of Manufacture',
        regMthYr: 'Registration Month / Year',
        vehBody: 'Body Type',
        engCCTonnage: 'Engine CC / Tonnage',
        maxLaden: 'Maximum Laden Weight',
        unLaden: 'Unladen Weight',
        noSeats: 'No. of Seats',
        mileage: 'Mileage',
        vehGrp: 'Vehicle Group',
        vehUse: 'Vehicle Usage',
        ownName: 'Owner Name',
        vehOwnICNo: 'Owner NRIC / ID',
        insdVal: 'New Car Purchase Price',
        hpOwn: 'Hire Purchase Owner',
        ncbYrPct: 'NCD Year / %',
        retnNCD: 'Retain NCD on Renewal',
        ltaTranDate: 'LTA Transmission Date',
        upldDate: 'LTA Update Date',
        // Miscellaneous Risk
        contrt: 'Contract No',
        // RI Detail
        riType: 'RI Type',
        riCo: 'RI Company',
        sumInsdPct: 'Sum Insured (%)',
        riPrem: 'Premium',
        comm1: 'Commission 1',
        comm2: 'Commission 2',
        cpmm3: 'Commission 3'
      },
      blkGrpColumns: [
        { text: 'Block Group', value: 'blkGrp' },
        { text: 'Block Group Description', value: 'blkGrpDescS' }
      ],
      blkSubGrp1Columns: [
        { text: 'Block Sub Group 1', value: 'blkSubGrp1' },
        { text: 'Block Sub Group 1 Description', value: 'blkSubGrp1DescS' }
      ],
      blkSubGrp2Columns: [
        { text: 'Block Sub Group 2', value: 'blkSubGrp2' },
        { text: 'Block Sub Group 2 Description', value: 'blkSubGrp2DescS' }
      ],
      blkColumns: [
        { text: 'Block', value: 'blk' },
        { text: 'Block Group', value: 'blkGrp' },
        { text: 'Block Description', value: 'blkDesc' }
      ],
      VslDetColumns: [
        { text: 'Vessel No', value: 'vesNo' },
        { text: 'Vessel Name', value: 'vesName' }
      ],
      riskAccumDetailForm: {
        // Standard
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrp: undefined,
        riskNo: undefined,
        riskDesc: undefined,
        busCls: undefined,
        busClsDesc: undefined,
        currency: undefined,
        currencyOri: undefined,
        siCurr: undefined,
        siCurrDesc: undefined,
        siExRate: undefined,
        billCurr: undefined,
        billCurrDesc: undefined,
        billCurrRate: undefined,
        comDate: undefined,
        expDate: undefined,
        ttSI: undefined,
        ttSIDisp: undefined,
        ttPremDue: undefined,
        ttPremDueDisp: undefined,
        totalSI: undefined,
        totalSIDisp: undefined,
        // Cargo Risk
        vesNo: undefined,
        vesName: undefined,
        voyNo: undefined,
        voyDet: undefined,
        voyDate: undefined,
        voyDateType: undefined,
        voyDateDesc: undefined,
        voyFromTo: undefined,
        portDep: undefined,
        portArr: undefined,
        portDepDesc: undefined,
        portArrDesc: undefined,
        voyDesc: undefined,
        voyDesc2: undefined,
        voyArea: undefined,
        voyAreaDesc: undefined,
        coverage: undefined,
        coverageDesc: undefined,
        comdtyType: undefined,
        comdtyTypeDesc: undefined,
        pkgType: undefined,
        pkgTypeDesc: undefined,
        surAgt: undefined,
        surAgtName: undefined,
        surAgtAddress1: undefined,
        surAgtAddress2: undefined,
        surAgtAddress3: undefined,
        surAgtAddress4: undefined,
        surAgtCty: undefined,
        surAgtPostalCode: undefined,
        setAgt: undefined,
        setAgtName: undefined,
        setAgtAddress1: undefined,
        setAgtAddress2: undefined,
        setAgtAddress3: undefined,
        setAgtAddress4: undefined,
        setAgtCty: undefined,
        setAgtPostalCode: undefined,
        certBord: undefined,
        certBordDesc: undefined,
        dclrCertNo: undefined,
        // Hull Risk
        vesDesc: undefined,
        issDate: undefined,
        intCvrd: undefined,
        intCvrdDesc: undefined,
        imoRefNo: undefined,
        chartRefNo: undefined,
        mortgagee: undefined,
        yrBuilt: undefined,
        vesFlag: undefined,
        vesFlagDesc: undefined,
        vesCls: undefined,
        vesClsDesc: undefined,
        vesType: undefined,
        vesTypeDesc: undefined,
        grt: undefined,
        nrt: undefined,
        dwt: undefined,
        vesConstn: undefined,
        vesConstnDesc: undefined,
        vesOwn: undefined,
        vesAgt: undefined,
        vesAgtName: undefined,
        // Fire Risk
        bldgNo: undefined,
        unitNo: undefined,
        collNo: undefined,
        interest: undefined,
        riskLoc: undefined,
        riskPostCode: undefined,
        occpy: undefined,
        occpCls: undefined,
        occpClsDesc: undefined,
        distCls: undefined,
        distClsDesc: undefined,
        constnCls: undefined,
        constnClsDesc: undefined,
        occpClsLim: undefined,
        occpClsLimDesc: undefined,
        ownTent: undefined,
        accmLdgPct: undefined,
        roof: undefined,
        noStorey: undefined,
        latitude: undefined,
        longitude: undefined,
        survRpt: undefined,
        survDate: undefined,
        // Motor Risk
        tarf: undefined,
        tarfDesc: undefined,
        cvrType: undefined,
        cvrTypeDesc: undefined,
        vehRegNo: undefined,
        colour: undefined,
        certNo: undefined,
        certRef: undefined,
        certRefDesc: undefined,
        trailerRegNo: undefined,
        engNo: undefined,
        chasNo: undefined,
        logBook: undefined,
        vehMake: undefined,
        modelNo: undefined,
        modelDesc: undefined,
        yrManuf: undefined,
        regYr: undefined,
        regMth: undefined,
        vehBody: undefined,
        engCc: undefined,
        tonnage: undefined,
        maxLaden: undefined,
        unLaden: undefined,
        noSeats: undefined,
        mileage: undefined,
        vehGrp: undefined,
        vehGrpDesc: undefined,
        vehUse: undefined,
        vehUseDesc: undefined,
        ownName: undefined,
        vehOwnIcNo: undefined,
        insdVal: undefined,
        hpOwn: undefined,
        ncbYr: undefined,
        ncbPct: undefined,
        retnNcd: undefined,
        ltaTranDate: undefined,
        upldDate: undefined,
        // Miscellaneous Risk
        contrt: undefined,
        // RI Detail
        riType: undefined,
        riCo: undefined,
        sumInsdPct: undefined,
        riPrem: undefined,
        comm1: undefined,
        comm2: undefined,
        comm3: undefined,
        // Block Detail
        accumType: undefined,
        blkGrpLblS: undefined,
        blkGrpLblL: undefined,
        blksGrp1LblS: undefined,
        blksGrp1LblL: undefined,
        blksGrp2LblS: undefined,
        blksGrp2LblL: undefined,
        blksLblS: undefined,
        blksLblL: undefined,
        delRisk: undefined,
        cfmRisk: undefined
      },
      // Transfer Form
      transferForm: {
        polNo: undefined,
        renCnt: undefined,
        transferType: undefined,
        accumType: undefined,
        blkGrpLblSFrom: undefined,
        blkGrpLblLFrom: undefined,
        blksGrp1LblSFrom: undefined,
        blksGrp1LblLFrom: undefined,
        blksGrp2LblSFrom: undefined,
        blksGrp2LblLFrom: undefined,
        blksLblSFrom: undefined,
        blksLblLFrom: undefined,
        blkGrpLblSTo: undefined,
        blkGrpLblLTo: undefined,
        blksGrp1LblSTo: undefined,
        blksGrp1LblLTo: undefined,
        blksGrp2LblSTo: undefined,
        blksGrp2LblLTo: undefined,
        blksLblSTo: undefined,
        blksLblLTo: undefined,
        transferAll: false
      },
      // Transfer Labels
      transferLabels: {
        accumType: 'Accumulation Type',
        blkGrpLblS: 'Block Group Label',
        blkGrpLblL: 'Block Group Description',
        blksGrp1LblS: 'Block Sub Group 1 Label',
        blksGrp1LblL: 'Block Sub Group 1 Description',
        blksGrp2LblS: 'Block Sub Group 2 Label',
        blksGrp2LblL: 'Block Sub Group 2 Description',
        blksLblS: 'Block Label',
        blksLblL: 'Block Description',
        transferAll: 'Transfer All Policies?'
      },
      // Extra Block Labels
      extraBlkLabels: {
        polNo: 'Policy No',
        curr: 'Currency',
        ttSI: 'Total Sum Insured',
        ttPremDue: 'Total Premium',
        accumType: 'Accumulation Type',
        blkGrpLblS: 'Block Group Label',
        blkGrpLblL: 'Block Group Description',
        blksGrp1LblS: 'Block Sub Group 1 Label',
        blksGrp1LblL: 'Block Sub Group 1 Description',
        blksGrp2LblS: 'Block Sub Group 2 Label',
        blksGrp2LblL: 'Block Sub Group 2 Description',
        blksLblS: 'Block Label',
        blksLblL: 'Block Description',
        floatSiLim: 'Block Sum Insured',
        floatPrem: 'Block Premium',
        voyDate: 'Voyage Date',
        voyDesc: 'Voyage Description',
        bldgNo: 'Building No.',
        unitNo: 'Unit No.'
      },
      // Extra Block Form
      extraBlkForm: {
        extraBlkAction: 'new',
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        seqNo: undefined,
        accmType: undefined,
        curr: undefined,
        currDesc: undefined,
        ttSI: undefined,
        ttPremDue: undefined,
        accumType: undefined,
        blkGrpLblS: undefined,
        blkGrpLblL: undefined,
        blksGrp1LblS: undefined,
        blksGrp1LblL: undefined,
        blksGrp2LblS: undefined,
        blksGrp2LblL: undefined,
        blksLblS: undefined,
        blksLblL: undefined,
        floatSiLim: 0,
        floatPrem: 0,
        voyDate: new Date(),
        voyDesc: undefined,
        bldgNo: undefined,
        unitNo: undefined
      },
      // Confirm Block Labels
      confirmBlkLabels: {
        polNo: 'Policy No',
        curr: 'Currency',
        ttSI: 'Total Sum Insured',
        ttPremDue: 'Total Premium',
        blkGrpLblS: 'Block Group Label',
        blkGrpLblL: 'Block Group Description',
        blksGrp1LblS: 'Block Sub Group 1 Label',
        blksGrp1LblL: 'Block Sub Group 1 Description',
        blksGrp2LblS: 'Block Sub Group 2 Label',
        blksGrp2LblL: 'Block Sub Group 2 Description',
        blksLblS: 'Block Label',
        blksLblL: 'Block Description'
      },
      // Confirm Block Form
      confirmBlkForm: {
        polNo: undefined,
        renCNt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        seqNo: undefined,
        accmType: undefined,
        curr: undefined,
        currDesc: undefined,
        ttSI: undefined,
        ttPremDue: undefined,
        accumType: undefined,
        blkGrpLblS: undefined,
        blkGrpLblL: undefined,
        blksGrp1LblS: undefined,
        blksGrp1LblL: undefined,
        blksGrp2LblS: undefined,
        blksGrp2LblL: undefined,
        blksLblS: undefined,
        blksLblL: undefined,
        cfmRisk: false
      },
      // Loading Percentage Labels
      loadingPctLabels: {
        polNo: 'Policy No',
        curr: 'Currency',
        ttSI: 'Total Sum Insured',
        ttPremDue: 'Total Premium',
        blkGrpLblS: 'Block Group Label',
        blkGrpLblL: 'Block Group Description',
        blksGrp1LblS: 'Block Sub Group 1 Label',
        blksGrp1LblL: 'Block Sub Group 1 Description',
        blksGrp2LblS: 'Block Sub Group 2 Label',
        blksGrp2LblL: 'Block Sub Group 2 Description',
        blksLblS: 'Block Label',
        blksLblL: 'Block Description',
        accmLdgPct: 'Loading %'
      },
      // Loading Percentage Form
      loadingPctForm: {
        polNo: undefined,
        renCNt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        seqNo: undefined,
        accmType: undefined,
        curr: undefined,
        currDesc: undefined,
        ttSI: undefined,
        ttSIDisp: undefined,
        ttPremDue: undefined,
        ttPremDueDisp: undefined,
        accumType: undefined,
        blkGrpLblS: undefined,
        blkGrpLblL: undefined,
        blksGrp1LblS: undefined,
        blksGrp1LblL: undefined,
        blksGrp2LblS: undefined,
        blksGrp2LblL: undefined,
        blksLblS: undefined,
        blksLblL: undefined,
        accmLdgPct: 0,
        loadingPctFound: false
      },
      riskAccumulationDto: {},
      supportedFormat: [],
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationRiskAccumDetail: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationBlkGrp: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationBlkSubGrp1: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationBlkSubGrp2: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationBlk: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationVslDet: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationAccumList: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationAccumList2: {
        sortDesc: [true],
        page: 1,
        itemsPerPage: 5
      },
      paginationFireRiskRI: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationCargoRiskRI: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationHullRiskRI: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationMotorRiskRI: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationMiscRiskRI: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationExtraBlkPolRiskBlk: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  computed: {
    listRiskAccumDetails() {
      let result = []
      for (const selectedRiskAccumDetailColumn of this.selectedRiskAccumDetailColumns) {
        let findCol = this.riskAccumDetailColumns.find(a => selectedRiskAccumDetailColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      // result.push(TableConst.tableActionHeader)
      return result
    },
    listRiskAccumDetailsFire() {
      // 210901 SSY: New columns in risk accumulation listing(Fire accumulation only)
      let result = []
      for (const selectedRiskAccumDetailFireColumn of this.selectedRiskAccumDetailFireColumns) {
        let findCol = this.riskAccumDetailColumns.find(a => selectedRiskAccumDetailFireColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      // result.push(TableConst.tableActionHeader)
      return result
    },
    listTreatyTotals() {
      let result = []
      for (const selectedTreatyTotalColumn of this.selectedTreatyTotalColumns) {
        let findCol = this.treatyTotalColumns.find(a => selectedTreatyTotalColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      // result.push(TableConst.tableActionHeader)
      return result
    },
    listBlkGrp() {
      let result = []
      for (const selectedBlkGrp of this.selectedBlkGrpsColumns) {
        let findCol = this.blkGrpColumns.find(a => selectedBlkGrp === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listBlkSubGrp1() {
      let result = []
      for (const selectedBlkSubGrp1 of this.selectedBlkSubGrp1Columns) {
        let findCol = this.blkSubGrp1Columns.find(a => selectedBlkSubGrp1 === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listBlkSubGrp2() {
      let result = []
      for (const selectedBlkSubGrp2 of this.selectedBlkSubGrp2Columns) {
        let findCol = this.blkSubGrp2Columns.find(a => selectedBlkSubGrp2 === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listBlk() {
      let result = []
      for (const selectedBlk of this.selectedBlkColumns) {
        let findCol = this.blkColumns.find(a => selectedBlk === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listVslDet() {
      let result = []
      for (const selectedVslDet of this.selectedVslDetColumns) {
        let findCol = this.VslDetColumns.find(a => selectedVslDet === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listRiskAccumFireRiskRI() {
      let result = []
      for (const selectedRiskAccumFireRiskRI of this.selectedRiskAccumFireRiskRIColumns) {
        let findCol = this.riskAccumColumns.find(a => selectedRiskAccumFireRiskRI === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    },
    listRiskAccumCargoRiskRI() {
      let result = []
      for (const selectedRiskAccumCargoRiskRI of this.selectedRiskAccumCargoRiskRIColumns) {
        let findCol = this.riskAccumColumns.find(a => selectedRiskAccumCargoRiskRI === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    },
    listRiskAccumHullRiskRI() {
      let result = []
      for (const selectedRiskAccumHullRiskRI of this.selectedRiskAccumHullRiskRIColumns) {
        let findCol = this.riskAccumColumns.find(a => selectedRiskAccumHullRiskRI === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    },
    listExtraBlk() {
      let result = []
      for (const selectedRiskAccumExtraBlk of this.selectedRiskAccumExtraBlkColumns) {
        let findCol = this.extraBlkColumns.find(a => selectedRiskAccumExtraBlk === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    accumBlkItemList() {
      const list = Object.freeze(this.accumBlkItem)
      return Object.keys(list).map(key => {
        return {
          label: list[key],
          value: key
        }
      })
    }
  },
  watch: {
    // RI Header
    paginationRiskAccumDetail: function(value) {
      this.checkAccumulation(false)
    },
    // BlkGrp
    paginationBlkGrp: function(value) {
      this.riskAccumBlkGrpInit(false)
    },
    // BlkSubGrp1
    paginationBlkSubGrp1: function(value) {
      this.riskAccumBlkSubGrp1Init(false)
    },
    // BlkSubGrp2
    paginationBlkSubGrp2: function(value) {
      this.riskAccumBlkSubGrp2Init(false)
    },
    // Blk
    paginationBlk: function(value) {
      this.riskAccumBlkInit(false)
    },
    // VslDet
    paginationVslDet: function(value) {
      this.riskAccumVslDetInit(false)
    },
    // AccumList
    paginationAccumList: function(value) {
      this.checkAccumulation(false)
    },
    paginationAccumList2: function(value) {
      this.getRiskAccumulationList2()
    },
    // FireRiskRI
    paginationFireRiskRI: function(value) {
      this.getFireRiskRI(false)
    },
    // CargoRiskRI
    paginationCargoRiskRI: function(value) {
      this.getCargoRiskRI(false)
    },
    // HullRiskRI
    paginationHullRiskRI: function(value) {
      this.getHullRiskRI(false)
    },
    // MotorRiskRI
    paginationMotorRiskRI: function(value) {
      this.getMotorRiskRI(false)
    },
    // MiscRiskRI
    paginationMiscRiskRI: function(value) {
      this.getMiscRiskRI(false)
    },
    // Extra Block - PolRiskBlk
    paginationExtraBlkPolRiskBlk: function(value) {
      this.getExtraBlkPolRiskBlkList(false)
    }
  },
  mixins: [TableConst.default]
}
